import script from "./AudienceCounter.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceCounter.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceCounter.vue?vue&type=style&index=0&id=828477e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-828477e4"]])

export default __exports__